import { render, staticRenderFns } from "./Softwaredownload.vue?vue&type=template&id=7046e03a&scoped=true&"
import script from "./Softwaredownload.vue?vue&type=script&lang=js&"
export * from "./Softwaredownload.vue?vue&type=script&lang=js&"
import style0 from "./Softwaredownload.vue?vue&type=style&index=0&id=7046e03a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046e03a",
  null
  
)

export default component.exports